declare namespace $ {

	export class $mol_icon_clock_fast extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=fast.view.tree.d.ts.map